@let isMobile = responsive.isMobile$ | async;

@if (isMobile) {
  <nz-layout class="mobile">
    <nz-content>
      <div class="w-full">
        <math-auth-informer>
          <nz-card>
            <router-outlet />
          </nz-card>
        </math-auth-informer>
      </div>
    </nz-content>
  </nz-layout>
}

@if (!isMobile) {
  <nz-layout>
    <nz-content>
      <nz-card>
        <nz-row class="auth-content" nzJustify="space-between">
          <nz-col nz-flex nzVertical [nzSpan]="isMobile ? 0 : 12">
            <math-auth-informer />
          </nz-col>

          <nz-col
            class="auth-content-main"
            nz-flex
            nzAlign="center"
            nzJustify="center"
            nzVertical
            [nzGap]="24"
            [nzSpan]="isMobile ? 24 : 12"
          >
            <router-outlet />
          </nz-col>
        </nz-row>
      </nz-card>
    </nz-content>
  </nz-layout>
}
